<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import { cn } from '@/lib/utils'

interface Props {
  class?: HTMLAttributes['class']
}

defineProps<Props>()
</script>

<template>
  <ul :class="cn('flex w-full flex-col gap-1', $props.class)">
    <slot />
  </ul>
</template>
